// Barrel export for layout components
export { default as Header } from '../../../shared/components/layout/Header/Header';

// Export types
export type { HeaderProps } from '../../../shared/components/layout/Header/HeaderProps';